import { Injectable } from '@angular/core';

@Injectable()
export class DialogDataStoreService {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/services/dialog-data-store/dialog-data-store.service.ts